import apiClient from '../clienteFebosAPI';

const RESOURCE = '/v2/buscar';

export const ioFilesSearch = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.get(
    `${RESOURCE}/archivos?${params}`,
    { operacionId: 'io.ed.repositorio.buscar' }
  );
};

export const ioExpedientesSearch = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.get(
    `${RESOURCE}/expedientes?${params}`,
    { operacionId: 'io.ed.expedientes.buscar' }
  );
};

export const ioMaterialRequestSearch = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(
    `${RESOURCE}/solicitud_material?${params}`,
    { operacionId: 'io.febos.solicitud_materiales.buscar' }
  );
};

/**
 * /v2/buscar/{indice}/indicadores
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
export const ioIndicadoresExpedientesSearch = (
  payload = {
    campos: '',
    filtros: ''
  }
) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(
    `${RESOURCE}/expedientes/indicadores?${params}`,
    { operacionId: 'io.ed.indicadores.expedientes.buscar' }
  );
};

export const ioGetFilesCSV = (request) => {
  const params = apiClient.queryParams(request);
  return apiClient.get(
    `${RESOURCE}/dte?${params}`,
    { operacionId: 'io.csv.documentos' }
  );
};

export const getAuctionIndicators = (request) => {
  const params = apiClient.queryParams(request);
  return apiClient.get(
    `${RESOURCE}/aduana_subasta/indicadores?${params}`,
    { operacionId: 'io.aduana.subasta.indicadores.get' }
  );
};

export const getBatchIndicators = (request) => {
  const params = apiClient.queryParams(request);
  return apiClient.get(
    `${RESOURCE}/aduana_lote/indicadores?${params}`,
    { operacionId: 'io.aduana.lotes.indicadores.get' }
  );
};

export const getReceiptIndicators = (request) => {
  const params = apiClient.queryParams(request);
  return apiClient.get(
    `${RESOURCE}/aduana_comprobante/indicadores?${params}`,
    { operacionId: 'io.aduana.comprobantes.indicadores.get' }
  );
};

export const downloadTrays = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.get(
    `${RESOURCE}/aprobaciones?${params}`,
    { operacionId: 'io.busqueda' }
  );
};
export const ioExpedientesSearchPost = ({ params, body }) => apiClient.post(
  `${RESOURCE}/expedientes?${apiClient.queryParams(params)}`,
  body,
  { operacionId: 'io.opensearch.buscar' }
);

export const searchTrays = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.get(
    `${RESOURCE}/aprobaciones?${params}`,
    { operacionId: 'io.busqueda' }
  );
};
